export default __webpack_public_path__ + "static/soehne-leicht-8f662c557d64720dda7a99665607303a.woff2";